<template>
  <div>
    <patternlib-modal
      :show="isVisible"
      @lhCancel="hide()"
      @lhClose="hide()"
      close
      hide-confirm
      :allow-close-on-backdrop="false"
      :height="displayBreakpoint === 'isMobile' ? mobileModalHeight : undefined"
      :max-height="
        displayBreakpoint === 'isMobile' ? mobileModalHeight : undefined
      "
    >
      <div slot="modal-content" :class="$gStyle('px-3')">
        <!-- Article -->
        <div>
          <b>{{ t('requestForm.selected_product') }}</b>
          <div
            v-for="(order, index) in orders"
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="flex-grow: 1"
              >{{
                `${order.qty}x ${order.articleName} - ${order.articleNumber}`
              }}
            </span>
            <patternlib-icon-button
              @click="() => removeOrder(index)"
              :disabled="isLoading"
            >
              <patternlib-icon icon-name="x"></patternlib-icon>
            </patternlib-icon-button>
          </div>
        </div>
        <!-- Information -->
        <div :class="$gStyle('mt-3')">
          <p>
            <b>
              {{ t('requestForm.options') }}
            </b>
            <br />
            {{ t('requestForm.second_text') }}
          </p>
          <p v-if="!!t('requestForm.third_text')">
            {{ t('requestForm.third_text') }}
          </p>
        </div>
        <!-- Input Forms -->
        <div :class="$gStyle('grid grid-cols-5 gap-4 mt-2')">
          <!-- Firstname -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.firstname')}*`"
              v-rule="
                groupedValidationRule(orderHead.firstName, 'form', requiredRule)
              "
              @lhChange="
                (event) => (orderHead.firstName = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Lastname -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.lastname')}*`"
              v-rule="
                groupedValidationRule(orderHead.lastName, 'form', requiredRule)
              "
              @lhChange="
                (event) => (orderHead.lastName = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Street -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.street')}*`"
              v-rule="
                groupedValidationRule(
                  orderHead.streetName,
                  'form',
                  requiredRule
                )
              "
              @lhChange="
                (event) => (orderHead.streetName = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Stree Number -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.streetnumber')}*`"
              v-rule="
                groupedValidationRule(
                  orderHead.houseNumber,
                  'form',
                  requiredRule
                )
              "
              @lhChange="
                (event) =>
                  (orderHead.houseNumber = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Postal Code -->
          <div :class="$gStyle('col-span-2')">
            <patternlib-textinput
              :label="`${t('requestForm.postalcode')}*`"
              v-rule="
                groupedValidationRule(orderHead.zipCode, 'form', requiredRule)
              "
              @lhChange="
                (event) => (orderHead.zipCode = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- City -->
          <div :class="$gStyle('col-span-3')">
            <patternlib-textinput
              :label="`${t('requestForm.city')}*`"
              v-rule="
                groupedValidationRule(orderHead.city, 'form', requiredRule)
              "
              @lhChange="
                (event) => (orderHead.city = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Mail -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.mail')}*`"
              v-rule="
                groupedValidationRule(
                  orderHead.email,
                  'form',
                  requiredRule,
                  emailRule
                )
              "
              type="email"
              @lhChange="
                (event) => (orderHead.email = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Mail Repeat -->
          <div :class="$gStyle('col-span-5')">
            <!-- Fix: Set Form with autocomplete off for edge-chromium -->
            <form class="input-container" autocomplete="off">
              <patternlib-textinput
                :label="`${t('requestForm.mailRepeat')}*`"
                v-rule="
                  groupedValidationRule(
                    [emailRepeat, orderHead.email],
                    'form',
                    requiredRule,
                    emailRepeatRule
                  )
                "
                onpaste="return false;"
                autocomplete="off"
                aria-autocomplete="none"
                list="off"
                type="email"
                @lhChange="
                  (event) => (emailRepeat = event.detail.value as string)
                "
              >
              </patternlib-textinput>
            </form>
          </div>
          <!-- Phone -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textinput
              :label="`${t('requestForm.phone')}*`"
              v-rule="
                groupedValidationRule(
                  orderHead.phoneNumber,
                  'form',
                  requiredRule
                )
              "
              @lhChange="
                (event) =>
                  (orderHead.phoneNumber = event.detail.value as string)
              "
            >
            </patternlib-textinput>
          </div>
          <!-- Message -->
          <div :class="$gStyle('col-span-5')">
            <patternlib-textarea-v1
              :label="t('requestForm.message')"
              type="text"
              size="small"
              required="false"
              width="100%"
              @lhChange="
                (event) => (orderHead.comment = event.detail.value as string)
              "
            ></patternlib-textarea-v1>
          </div>
        </div>
        <hr />
        <!-- Agreement -->
        <div :class="$gStyle('mt-3')">
          <span :class="$gStyle('font-bold')">{{
            $t('requestForm.legal')
          }}</span>
          <br />
          <div
            id="legalText"
            v-html="
              t('requestForm.legalText', {
                HauSparePartsFormLegalTextUrl: getWebsiteConfigPage(
                  'HauSparePartsFormLegalTextUrl'
                ).value
              })
            "
          ></div>
        </div>
        <!-- Custom Divider -->
        <div :class="$gStyle('relative flex py-5 items-center')">
          <div class="custom-border"></div>
          <span
            :class="$gStyle('flex-shrink mx-5')"
            style="font-weight: bold"
            >{{ t('requestForm.or') }}</span
          >
          <div class="custom-border"></div>
        </div>
        <!-- Telephone -->
        <div>
          {{ t('requestForm.serviceHotline') }}
          <a
            style="
              font-size: var(--h6-font-size);
              font-weight: bold;
              display: block;
            "
            :class="$gStyle('mt-3')"
            :href="'tel:' + internationalPhone"
          >
            {{ t('requestForm.telephone') }}: {{ nationalPhone }}
          </a>
        </div>
      </div>
      <div
        slot="modal-footer"
        class="modal-footer"
        :class="{ 'modal-footer-mobile': displayBreakpoint === 'isMobile' }"
      >
        <patternlib-button
          type="secondary"
          :label="t('requestForm.cancel')"
          @click="hide()"
        ></patternlib-button>
        <patternlib-button
          :label="t('requestForm.confirm')"
          :disabled="orders.length === 0 || hasGroupError('form')"
          :loading="isLoading"
          icon-position="right"
          @click="!isLoading && send()"
        >
          <patternlib-icon
            iconName="font-arrow"
            size="24px"
            slot="icon"
          ></patternlib-icon>
        </patternlib-button>
      </div>
    </patternlib-modal>
  </div>
</template>

<script setup lang="ts">
  import { useValidation } from '@liebherr/form-validator-vue';
  import { storeToRefs } from 'pinia';
  import {
    inject,
    onBeforeUnmount,
    onMounted,
    ref,
    watch,
    type Ref
  } from 'vue';
  import { useOrderStore } from '../stores/order';

  const {
    requiredRule,
    emailRule,
    emailRepeatRule,
    groupedValidationRule,
    hasGroupError
  } = useValidation();

  const createToast: any = inject('createToast');
  const displayBreakpoint: Ref<string, string> | undefined =
    inject('displayBreakpoint');

  import type { AxiosError } from 'axios';
  import { useI18n } from 'vue-i18n';
  import { isLoading } from '../axios.global';
  import { useDataStore } from '../stores/data';
  const { t } = useI18n();

  const emailRepeat = ref('');

  const isVisible = ref(false);
  const mobileModalHeight = ref('100dvh');

  const updateMobileModalHeight = () => {
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
    mobileModalHeight.value = `${Math.floor(viewportHeight)}px`;
  };

  onMounted(() => {
    updateMobileModalHeight();
    window.visualViewport?.addEventListener('resize', updateMobileModalHeight);
    window.addEventListener('resize', updateMobileModalHeight);
  });

  onBeforeUnmount(() => {
    window.visualViewport?.removeEventListener(
      'resize',
      updateMobileModalHeight
    );
    window.removeEventListener('resize', updateMobileModalHeight);
  });

  const documentElementOverflow = document.documentElement.style.overflow;
  const bodyOverflow = document.body.style.overflow;

  const setDocumentScrollLock = (locked: boolean) => {
    document.documentElement.classList.toggle('modal-scroll-locked', locked);
    document.body.classList.toggle('modal-scroll-locked', locked);
    document.documentElement.style.overflow = locked
      ? 'hidden'
      : documentElementOverflow;
    document.body.style.overflow = locked ? 'hidden' : bodyOverflow;
  };

  watch(isVisible, setDocumentScrollLock);
  onBeforeUnmount(() => setDocumentScrollLock(false));

  const show = () => (isVisible.value = true);
  const hide = () => (isVisible.value = false);

  const dataStore = useDataStore();
  const { getWebsiteConfigPage } = dataStore;
  const { nationalPhone, internationalPhone } = storeToRefs(dataStore);

  const orderStore = useOrderStore();
  const { orders, orderHead } = storeToRefs(orderStore);
  const { removeOrder, sendFormular } = orderStore;
  defineExpose({ show, hide });

  const emit = defineEmits(['showSuccessResponse', 'showErrorResponse']);

  const send = () => {
    sendFormular()
      .then(() => {
        hide();
        emit('showSuccessResponse');
      })
      .catch((_err: AxiosError) => {
        hide();
        emit('showErrorResponse');
        createToast(t('requestForm.result_failure_message'));
      });
  };
</script>

<style scoped>
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-3);
  }

  .modal-footer-mobile {
    flex-direction: column;
    padding-bottom: 50px;
  }

  .modal-footer-mobile patternlib-button {
    width: 100%;
  }

  :global(html.modal-scroll-locked),
  :global(body.modal-scroll-locked) {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  :global(html.modal-scroll-locked::-webkit-scrollbar),
  :global(body.modal-scroll-locked::-webkit-scrollbar) {
    display: none;
  }

  hr {
    margin-block: calc(12px);
    height: calc(var(--spacing) * 0.5);
    border-top-style: var(--tw-border-style);
    border-top-width: 0px;
    background-color: var(--color-neutral-100);
  }

  .custom-border {
    border-top-style: var(--tw-border-style);
    border-top-width: 2px;
    border-color: var(--color-neutral-900);
    flex-grow: 1;
    min-width: 0;
  }

  #legalText :deep(a) {
    text-decoration: underline;
  }
</style>
